// assets
import { SendOutlined, ToolOutlined } from '@ant-design/icons';

// icons
const icons = { SendOutlined, ToolOutlined };

// ==============================|| MENU ITEMS - MOVIMIENTOS ||============================== //

const movimientos = {
  id: 'movimientos',
  title: 'Movimientos',
  type: 'group',
  children: [
    {
      id: 'envios',
      title: 'Envíos',
      type: 'item',
      url: '/envios',
      icon: icons.SendOutlined
    },
    {
      id: 'reparacion-ahorros',
      title: 'Reparación de Ahorros',
      type: 'item',
      url: '/reparacion-ahorros',
      icon: icons.ToolOutlined
    }
  ]
};

export default movimientos;
